<span class="field-view-value field-value-id">{{value || '—'}}</span>
